<h4 class="" [ngClass]="{'error': !successMessage, 'success-green-dark': successMessage}">
  <span aria-hidden="true" class="icon icon--big" [ngClass]="{'icon--alert-full': !successMessage, 'icon--checkmark': successMessage}"></span>
  <span [innerHTML]="messageTitle"></span>
</h4>
<p [innerHTML]="message"></p>

@if (!successMessage) {
  <a attr.href="{{ 'links.back.url' | translate }}" class="btn btn--primary mr-1">{{ 'links.back.name' | translate }}</a>
}
<a attr.href="{{ 'links.uoc.url' | translate }}" class="text-small">{{ 'links.uoc.name' | translate }}</a>
